import { useTheme } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { getCountToText } from '@utils';
import { StatCardsProps } from './types';

export default function StatCards(props: Readonly<StatCardsProps>) {
  const { events = [], following = [], friendships } = props.consumer;
  const theme = useTheme();
  const { t } = useTranslation('cta');

  if (!props.consumer) {
    return null;
  }

  return (
    <Stack spacing={3} px={2} width="100%">
      <Stack spacing={1} direction="row" width="100%" justifyContent="space-between">
        <Stack
          alignItems="center"
          width="100%"
          py={2}
          sx={{ backgroundColor: theme.palette.background.paper, borderRadius: theme.borderRadius }}
        >
          <Typography variant="body1" color="textPrimary" fontWeight="bold">
            {getCountToText(events.length)}
          </Typography>
          <Typography variant="body1" color="textSecondary" fontSize={{ xs: '.7rem', sm: '.8rem' }}>
            {`event${events.length > 1 ? 's' : ''}`}
          </Typography>
        </Stack>
        <Stack
          alignItems="center"
          width="100%"
          py={2}
          sx={{ backgroundColor: theme.palette.background.paper, borderRadius: theme.borderRadius }}
        >
          <Typography variant="body1" color="textPrimary" fontWeight="bold">
            {getCountToText(following.length)}
          </Typography>
          <Typography variant="body1" color="textSecondary" fontSize={{ xs: '.7rem', sm: '.8rem' }}>
            {`spot${following.length > 1 ? 's' : ''}`}
          </Typography>
        </Stack>
        {/* <Stack
          alignItems="center"
          width="100%"
          py={2}
          sx={{ backgroundColor: theme.palette.background.paper, borderRadius: theme.borderRadius }}
        >
          <Typography variant="body1" color="textPrimary" fontWeight="bold">
            {getCountToText(following.length)}
          </Typography>
          <Typography variant="body1" color="textSecondary" fontSize={{ xs: '.7rem', sm: '.8rem' }}>
            {`idole${following.length > 1 ? 's' : ''}`}
          </Typography>
        </Stack> */}
        <Stack
          alignItems="center"
          width="100%"
          py={2}
          sx={{ backgroundColor: theme.palette.background.paper, borderRadius: theme.borderRadius }}
        >
          <Typography variant="body1" color="textPrimary" fontWeight="bold">
            {getCountToText(friendships.active.count)}
          </Typography>
          <Typography variant="body1" color="textSecondary" fontSize={{ xs: '.7rem', sm: '.8rem' }}>
            {t('word.friend', { count: friendships.active.count, ns: 'common' })}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
